import BannerSelect from './BannerSelect'

export default BannerSelect
